import sendBasketReq from './helpers/basketFetch';

const changeHandler = async (evt) => {
  evt.preventDefault();

  const formElem = evt.target.closest('form#cart-import-form');
  if (!formElem) return;

  const formData = new FormData(formElem);
  formData.append('action', 'import-csv');

  const URL = '/local/ajax/basket/index.php';
  const { importFileToCart } = await sendBasketReq(formData, URL, 'json');

  if (importFileToCart) {
    if (importFileToCart?.empty_file) {
      const firstLine = 'Файл пуст. Добавьте в него артикулы и количество товаров.';
      const secondLine = 'Страница будет перезагружена через 3 секунды';
      window.popupOpenUniversalForm('Ошибка', `${firstLine}<br>${secondLine}`);
    }

    if (importFileToCart && !importFileToCart.bad_file && importFileToCart.data) {
      const firstLine = `Загружен${importFileToCart?.data.length > 1 ? 'о' : ''} ${importFileToCart?.data?.length} товара`;
      const secondLine = 'Страница будет перезагружена через 3 секунды';
      window.popupOpenUniversalForm('', `${firstLine}<br>${secondLine}`);
    }

    setTimeout(() => {
      window.location.reload();
    }, 3000);
  } else {
    window.popupOpenUniversalForm('', 'Не удалось загрузить файл. Повторите попытку позже');
  }
};

const init = () => {
  const fileInput = document.getElementById('cart-import-file');

  if (fileInput && !fileInput.classList.contains('_init')) {
    fileInput.addEventListener('change', changeHandler);
    fileInput.classList.add('_init');
  }
};

init();

window.initImportFileHandler = init;
